import { render, staticRenderFns } from "./header-notification.vue?vue&type=template&id=e3256212"
import script from "./header-notification.vue?vue&type=script&lang=js"
export * from "./header-notification.vue?vue&type=script&lang=js"
import style0 from "./header-notification.vue?vue&type=style&index=0&id=e3256212&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports